import { SvgIcon } from '@material-ui/core';
import React from 'react';

export default function NotesIcon({
  styles,
}: {
  styles?: React.CSSProperties;
}) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      style={styles}
    >
      <path
        d="M12.4998 1.6665H7.49984C7.0396 1.6665 6.6665 2.0396 6.6665 2.49984V4.1665C6.6665 4.62674 7.0396 4.99984 7.49984 4.99984H12.4998C12.9601 4.99984 13.3332 4.62674 13.3332 4.1665V2.49984C13.3332 2.0396 12.9601 1.6665 12.4998 1.6665Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.3335 3.3335H15.0002C15.4422 3.3335 15.8661 3.50909 16.1787 3.82165C16.4912 4.13421 16.6668 4.55814 16.6668 5.00016V16.6668C16.6668 17.1089 16.4912 17.5328 16.1787 17.8453C15.8661 18.1579 15.4422 18.3335 15.0002 18.3335H5.00016C4.55814 18.3335 4.13421 18.1579 3.82165 17.8453C3.50909 17.5328 3.3335 17.1089 3.3335 16.6668V5.00016C3.3335 4.55814 3.50909 4.13421 3.82165 3.82165C4.13421 3.50909 4.55814 3.3335 5.00016 3.3335H6.66683"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
